require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
require('../../modules/es6.array.of');
require('../../modules/es6.array.species');
require('../../modules/es6.array.iterator');
require('../../modules/es6.array.copy-within');
require('../../modules/es6.array.fill');
require('../../modules/es6.array.find');
require('../../modules/es6.array.find-index');
require('../../modules/es7.array.includes');
require('../../modules/js.array.statics');
module.exports = require('../../modules/$.core').Array;


// WEBPACK FOOTER //
// ./node_modules/core-js/fn/array/index.js